/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
import { API_ENDPOINTS } from 'constants'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  sendContact: (data) => {
    return axios.post(API_ENDPOINTS.SEND_CONTACT, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },

  getMetalTypes: () => {
    return axios.get(API_ENDPOINTS.GET_METAL_TYPES, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  sendCustomRequest: (data) => {
    return axios.post(API_ENDPOINTS.SEND_CUSTOM_REQUEST, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
}
